/* v8 ignore file -- @preserve */
import { RESTORES_FEEDBACK_VIEW_HANDLE } from "@appretio/feedback";
import { LazyRoute } from "@appretio/shared";
import { ErrorBoundary, semanticThemeTokens } from "@appretio/ui-kit";
import { lazy } from "react";
import { Outlet, type RouteObject } from "react-router-dom";

const TradexPage = lazy(() =>
  import("./tradexPage/TradexPage").then((m) => ({
    default: m.TradexPage
  }))
);

const PlaybookPage = lazy(() =>
  import("./playbookPage/PlaybookPage").then((m) => ({
    default: m.PlaybookPage
  }))
);

const MarkdownMonitorPage = lazy(() =>
  import("./markdownMonitorPage/MarkdownMonitorPage").then((m) => ({
    default: m.MarkdownMonitorPage
  }))
);

const ROOT = "lifecycle-management/tradex" as const;
const PATH = {
  TRADEX: "trade-actions",
  PLAYBOOK: "playbook",
  MARKDOWN_MONITOR: "markdown-monitor"
} as const;

const LABEL = {
  ROOT: "Lifecycle Management",
  TRADEX: "Trade Actions",
  PLAYBOOK: "Playbook",
  MARKDOWN_MONITOR: "Markdown Monitor"
} as const;

const BG = semanticThemeTokens.backgroundGradient[4];

/** Pages not yet released: registered, and in the nav, outside production only. */
export function unreleasedLifecycleRoutes(
  environment: string | undefined
): RouteObject[] {
  return environment === "production"
    ? []
    : [
        {
          path: PATH.MARKDOWN_MONITOR,
          handle: { label: LABEL.MARKDOWN_MONITOR },
          element: (
            <ErrorBoundary level="route">
              <LazyRoute>
                <MarkdownMonitorPage />
              </LazyRoute>
            </ErrorBoundary>
          )
        }
      ];
}

export const lifecycleRoutes: RouteObject = {
  path: ROOT,
  element: <Outlet />,
  handle: { label: LABEL.ROOT, background: BG },
  children: [
    {
      path: PATH.TRADEX,
      // Hydrates from a feedback restore (useTradexStateRestore); pages
      // without this marker get the app layout's "not restored" notice.
      handle: { label: LABEL.TRADEX, ...RESTORES_FEEDBACK_VIEW_HANDLE },
      element: (
        <ErrorBoundary level="route">
          <LazyRoute>
            <TradexPage />
          </LazyRoute>
        </ErrorBoundary>
      )
    },
    {
      path: PATH.PLAYBOOK,
      handle: { label: LABEL.PLAYBOOK },
      element: (
        <ErrorBoundary level="route">
          <LazyRoute>
            <PlaybookPage />
          </LazyRoute>
        </ErrorBoundary>
      )
    },
    ...unreleasedLifecycleRoutes(import.meta.env.VITE_ENVIRONMENT)
  ]
};
